import { all, fork } from "redux-saga/effects";
import authSaga from "./auth/authSaga";
import employeeSaga from "./employee/employeeSaga";
import menuSaga from "./menu/manuSaga";
import subscriptionSaga from "./subscription/subscriptionSaga";
import paymentSaga from "./payment/paymentSaga";
import productCatalogSaga from "./productCatalog/productCatalogSaga";
import offerSaga from "./offer/offerSaga";
import newReportsSagas from "./newReports/newReportsSagas";
import Display from './Display/DisplaySaga'
import checkInReportsSaga from "./checkInReports/checkInReportsSagas";
import productReportsSaga from "./productReports/productReportsSagas";
import customerInsightsSaga from "./customerInsights/customerInsightsSagas";
import staffReportsSagas from "./staffReports/staffReportsSagas";
import reservationReportsSaga from "./reservationReports/reservationReportsSagas";
import eventReportsSaga from "./eventReports/eventReportsSagas";
import eodReportsSaga from "./eodReports/eodReportsSagas";
import salesEmployeeTabSliceSagas from "./salesEmployeeTabSlice/salesEmployeeTabSliceSagas"

// Redux Saga: Root Saga
export default function* rootSaga() {
  yield all([
    fork(authSaga),
    fork(employeeSaga),
    fork(menuSaga),
    fork(subscriptionSaga),
    fork(paymentSaga),
    fork(productCatalogSaga),
    fork(offerSaga),
    fork(newReportsSagas),
    fork(Display),
    fork(checkInReportsSaga),
    fork(productReportsSaga),
    fork(customerInsightsSaga),
    fork(staffReportsSagas),
    fork(reservationReportsSaga),
    fork(eventReportsSaga),
    fork(eodReportsSaga),
    fork(salesEmployeeTabSliceSagas)
  ]);
}
